export default __webpack_public_path__ + "static/media/icon-lang.8e360791.svg";